import Config from '@config';
import { initializeAdmissionClassesApi } from '@gasbi/shared';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const admissionClasses = initializeAdmissionClassesApi({
  baseUrl: Config.VITE_API_CLIENT_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  admissionClassesApi,
  useGetAdmissionClassesIInfiniteQuery,
  useGetAdmissionClassesQuery,
} = admissionClasses;
